import { type NavigationGuardNext, type RouteLocationNormalized } from 'vue-router'
import { useAuth } from '../composables/src/useAuth'
import { useAccountStore } from '../stores/account'
import { useCompanyStore } from '../stores/companies'
import { useTeamStore } from '../stores/teams'
import { useTicketStore } from '../stores/tickets'
import { useWorkflowStore } from '../stores/workflows'

export async function authGuard(to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) {
  if (!to.meta.requiresAuth) {
    return next()
  }

  const auth = useAuth()
  const accountStore = useAccountStore()
  const companyStore = useCompanyStore()
  const teamStore = useTeamStore()
  const ticketStore = useTicketStore()
  const workflowStore = useWorkflowStore()

  if (auth.isLoading.value) {
    return next(false)
  }

  if (!auth.isAuthenticated.value) {
    auth.login()

    return
  } else {
    if (!accountStore.user.id) {
      await Promise.allSettled([
        accountStore.setUser(),
        teamStore.fetchTeams(),
        ticketStore.fetchSettings(),
        companyStore.fetchCompanies(false),
        workflowStore.loadAllWorkflowConfigs(),
      ])
    }
  }
  next()
}
